import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { INBOX_TYPES } from './inbox';

// Rótulo de seleção; nunca altera o nome cadastrado da caixa.
export const getInboxLabel = (inbox = {}) => {
  const name = inbox.name || '';
  const channelType = inbox.channel_type || inbox.channelType;
  const phone = inbox.phone_number || inbox.phoneNumber;
  if (
    channelType !== INBOX_TYPES.WHATSAPP ||
    inbox.provider !== 'whatsapp_cloud' ||
    !phone
  ) {
    return name;
  }

  const rawPhone = String(phone).trim();
  const digits = rawPhone.replace(/\D/g, '');
  if (!digits) return name;
  const parsed = parsePhoneNumberFromString(`+${digits}`);
  let formatted = parsed?.isValid() ? parsed.formatInternational() : rawPhone;
  if (parsed?.country === 'BR') {
    formatted = formatted
      .replace(/^\+55\s*/, '')
      .replace(/(\d{4,5}) (\d{4})$/, '$1-$2');
  }

  // Algumas caixas antigas já têm o mesmo telefone entre parênteses no nome.
  const suffix =
    name.match(/(?:\s+-)?\s*\[([+\d][\d\s().-]*)\]\s*$/) ||
    name.match(/(?:\s+-\s+|\s*\()([+\d][\d\s().-]*)\)?\s*$/);
  const suffixDigits = suffix?.[1].replace(/\D/g, '');
  const samePhone =
    suffixDigits === digits ||
    (parsed?.country === 'BR' && suffixDigits === parsed.nationalNumber);
  const baseName = samePhone ? name.slice(0, suffix.index).trim() : name;
  return baseName ? `${baseName} - [${formatted}]` : `[${formatted}]`;
};
